import { render, staticRenderFns } from "./SurveyStep2.vue?vue&type=template&id=f6e73e2a&scoped=true&"
import script from "./SurveyStep2.vue?vue&type=script&lang=js&"
export * from "./SurveyStep2.vue?vue&type=script&lang=js&"
import style0 from "./SurveyStep2.vue?vue&type=style&index=0&id=f6e73e2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e73e2a",
  null
  
)

export default component.exports